import { render, staticRenderFns } from "./resive.vue?vue&type=template&id=ed3d5f0e&scoped=true"
import script from "./resive.vue?vue&type=script&lang=js"
export * from "./resive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3d5f0e",
  null
  
)

export default component.exports